/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for LicencePlanResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetLicencePlanByIdResponse, GetLicencePlansResponse, GetLicencePlanSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class LicencePlanResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getLicencePlanById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetLicencePlanByIdResponse, unknown> & { defaultValue: NoInfer<GetLicencePlanByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlanByIdResponse>;
    getLicencePlanById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetLicencePlanByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlanByIdResponse | undefined>;
    getLicencePlanById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetLicencePlanByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlanByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/LicencePlan/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getLicencePlans(resourceOptions: HttpResourceOptions<GetLicencePlansResponse, unknown> & { defaultValue: NoInfer<GetLicencePlansResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlansResponse>;
    getLicencePlans(resourceOptions?: HttpResourceOptions<GetLicencePlansResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlansResponse | undefined>;
    getLicencePlans(resourceOptions?: HttpResourceOptions<GetLicencePlansResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlansResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/LicencePlan`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getLicencePlanSelect(resourceOptions: HttpResourceOptions<GetLicencePlanSelectResponse, unknown> & { defaultValue: NoInfer<GetLicencePlanSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlanSelectResponse>;
    getLicencePlanSelect(resourceOptions?: HttpResourceOptions<GetLicencePlanSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlanSelectResponse | undefined>;
    getLicencePlanSelect(resourceOptions?: HttpResourceOptions<GetLicencePlanSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLicencePlanSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/LicencePlan/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
